import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../core/core.module";
import { FormsModule } from "../forms/forms.module";
import { RouterModule } from "@angular/router";
import { SwiperModule } from "ngx-swiper-wrapper";
import { ActivityCardComponent } from "./components/activity-card/activity-card.component";
import { ActivityCardsComponent } from "./components/activity-cards/activity-cards.component";
import { ActivityListComponent } from "./components/activity-list/activity-list.component";
import { ActivityDataEntryComponent } from "./components/activity-data-entry/activity-data-entry.component";
import { ActivityFileUploadComponent } from "./components/activity-file-upload/activity-file-upload.component";
import { ActivityTypeBaseComponent } from "./components/activity-type-base/activity-type-base.component";
import { RubblSharedModule } from "../rubbl-shared/rubbl-shared.module";
import { ActivityBooleanComponent } from "./components/activity-boolean/activity-boolean.component";
import { ActivityMachineAvailabilityComponent } from "./components/activity-machine-availability/activity-machine-availability.component";
import { ActivityRenterVerificationComponent } from "./components/activity-renter-verification/activity-renter-verification.component";
import { ActivityInspectionComponent } from "./components/activity-inspection/activity-inspection.component";
import { InspectionsModule } from "../inspections/inspections.module";

@NgModule({
  declarations: [
    ActivityTypeBaseComponent,
    ActivityCardComponent,
    ActivityCardsComponent,
    ActivityListComponent,
    ActivityDataEntryComponent,
    ActivityFileUploadComponent,
    ActivityBooleanComponent,
    ActivityMachineAvailabilityComponent,
    ActivityRenterVerificationComponent,
    ActivityInspectionComponent,
  ],
  imports: [CommonModule, FormsModule, CoreModule, RouterModule, SwiperModule, RubblSharedModule, InspectionsModule],
  exports: [
    ActivityCardComponent,
    ActivityCardsComponent,
    ActivityListComponent,
    ActivityDataEntryComponent,
    ActivityFileUploadComponent,
    ActivityBooleanComponent,
    ActivityMachineAvailabilityComponent,
    ActivityRenterVerificationComponent,
    ActivityInspectionComponent,
  ],
})
export class ActivityModule {}
